import type { ReactNode } from 'react'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import { Sidebar } from './Sidebar'
import { SiteFooter } from './SiteFooter'
import { SiteHeader } from './SiteHeader'
import { SiteLinks } from './SiteLinks'

/** Three-zone docs shell: sticky category nav, article column, optional rail. */
export function DocsLayout({
  children,
  activeCategorySlug,
  activeArticleId,
  rail,
}: {
  children: ReactNode
  activeCategorySlug?: string | null
  activeArticleId?: string | null
  rail?: ReactNode
}) {
  const [isNavOpen, setIsNavOpen] = useState(false)
  const location = useLocation()

  useEffect(() => {
    setIsNavOpen(false)
  }, [location.pathname])

  return (
    <div className="shell">
      <SiteHeader
        onToggleNav={() => setIsNavOpen(open => !open)}
        isNavOpen={isNavOpen}
      />
      <div className={`docs${isNavOpen ? ' nav-open' : ''}`}>
        <aside className="docs-nav">
          <nav className="drawer-site-links" aria-label="Scrambl">
            <SiteLinks onNavigate={() => setIsNavOpen(false)} />
          </nav>
          <Sidebar
            activeCategorySlug={activeCategorySlug}
            activeArticleId={activeArticleId}
            onNavigate={() => setIsNavOpen(false)}
          />
        </aside>
        <main className="docs-main">{children}</main>
        <aside className="docs-rail">{rail}</aside>
      </div>
      <SiteFooter />
    </div>
  )
}
